import * as React from "react";
import { action } from "mobx";
import { observer } from "mobx-react";
import { PreviewStore } from "../Stores/PreviewStore";
import { Strings } from "../Stores/StringsStore";

export interface IViewCardButtonProps {
	id?: string;
	disabled?: boolean;
	testId?: string;
	testName?: string;
	store: PreviewStore;
}

@observer
export class ViewCard extends React.Component<IViewCardButtonProps, {}> {

	@action onClick = () => {
		this.props.store.showPreviews = true;
	}

	render() {
		let className = !this.props.store.showPreviews ? "button" : "button is--button-highlight";
		return <button id={this.props.id} className={className} disabled={this.props.disabled} onClick={this.onClick} data-test-id={this.props.testId} data-test-name={this.props.testName} title={Strings.reader.viewCardButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<rect x="4" y="4" width="10" height="10" />
					<rect x="18" y="4" width="10" height="10" />
					<rect x="4" y="18" width="10" height="10" />
					<rect x="18" y="18" width="10" height="10" />
				</svg>
			</i>
		</button>;
	}
}
